import { env } from "@/config";
import { getSelectedSessionId } from "@/sdk";
import { getSharedApiClient } from "@/shared-utils";

export const getCustomerDetailsApi = () => {
    return getSharedApiClient(getSelectedSessionId()).extend(() => ({
        prefixUrl: `${env.apiBaseUrl}/api/customer`,
    }));
};
